'use client';

import { FC, useEffect } from 'react';

import { initScrollDirection } from 'src/general/helpers/initScrollDirection';

/** Component in charge of watching the page scroll */
export const ScrollWatcher: FC = () => {
  useEffect(() => {
    const { removeScrollDirectionListener } = initScrollDirection();

    return () => {
      removeScrollDirectionListener();
    };
  }, []);

  return null;
};
